import { signInUser, checkTokenType, getAccessToken, sendOTP } from './states';

export const services = {
  signInUser,
  checkTokenType,
  getAccessToken,
  sendOTP,
};
